import { Divider as CdsDivider } from '@cbhq/cds-web/layout/Divider'

import type { RenderNodePropsTypes } from '../types'

export const Divider = (): RenderNodePropsTypes => {
  return function divider() {
    return <CdsDivider color="line" />
  }
}
